import { InfoCircleOutlined } from '@ant-design/icons/lib/icons'
import { Row } from 'antd'
import Form from 'app/components/Core/InvoicePayment/Form'
import SolvencyCheck from 'app/components/Core/Solvency/Check'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { PaymentTypeEnum, RentalSuccessStatus } from 'app/constants/Enums'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { PaymentContainerProps } from './typing'

const Invoice: React.FC<PaymentContainerProps> = ({ quote, portalId, route }) => {
  const navigate = useNavigate()
  const { tRoute } = useTranslation({ scope: route.key })
  const { parameterize } = ToolBox
  const customer = useCurrentCustomer()
  const [eligible, setEligible] = useState<boolean>()
  const { payment_id: rental_id } = useParams<{ payment_id: string }>()

  const onSuccess = () => {
    if (customer?.has_klarx_manager_access) {
      navigate(
        {
          pathname: Routes.Rental.member(String(quote?.rental?.id)).show,
          search: parameterize({ success: RentalSuccessStatus.accepted })
        },
        { replace: true }
      )
    } else {
      navigate(
        {
          pathname: Routes.Payment.member(String(quote?.rental?.id)).confirmation,
          search: parameterize({ payment_option: PaymentTypeEnum.invoice })
        },
        { replace: true }
      )
    }
  }

  return (
    <Row>
      <KCol span={24} loading={!customer}>
        <Choose>
          <When condition={!eligible}>
            <SolvencyCheck rental_id={Number(rental_id)} onSuccess={() => setEligible(true)} />
          </When>
          <Otherwise>
            <If condition={quote}>
              <Form
                props={{ onSuccess, portalId }}
                member={{
                  id: null,
                  quote_id: quote?.id,
                  rental_id: quote?.rental.id
                }}>
                <Row gutter={[0, 24]}>
                  <KCol span={24}>
                    <Row>
                      <KCol span={2}>
                        <InfoCircleOutlined className="text-xl" />
                      </KCol>
                      <KCol span={22}>{tRoute({ id: 'payment_contact' })}</KCol>
                    </Row>
                  </KCol>
                  <KCol span={24}>{tRoute({ id: 'payment_info' })}</KCol>
                </Row>
              </Form>
            </If>
          </Otherwise>
        </Choose>
      </KCol>
    </Row>
  )
}

export default Invoice
